module.exports = __webpack_public_path__ + "static/media/volkswagen.9d9246f8.svg";